import { Component, OnInit } from '@angular/core';
import { FlowManagementService } from '../services/flow-management.service';

@Component({
    selector: 'app-promotion',
    templateUrl: './promotion.component.html',
    styleUrls: ['./promotion.component.css'],
    standalone: false
})
export class PromotionComponent implements OnInit {

  constructor(private flowManagementService: FlowManagementService) { }

  tryCoupon: string = '';
  coupon: string = '';
  discount = 0;
  couponText = '';

  ngOnInit() {
  }

  verify() {
    this.flowManagementService.verifyCoupon(this.tryCoupon).then( (res:any)=>{

      this.coupon = res.coupon;
      this.discount = res.discount;
      this.couponText = res.couponText;
  
    });
  }
}
